// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WarningFilledSvg from "@ant-design/icons-svg/es/asn/WarningFilled";
import AntdIcon from '../components/AntdIcon';

var WarningFilled = function WarningFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WarningFilledSvg
  }));
};

WarningFilled.displayName = 'WarningFilled';
export default React.forwardRef(WarningFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/WarningFilled.js
// module id = 2045
// module chunks = 0